export const PARTNER_TAGS = 'tags'
export const SET_PARTNER_TAGS = PARTNER_TAGS + '/SET_PARTNER_TAGS'
export const TOGGLE_PARTNER_TAG = PARTNER_TAGS + '/TOGGLE_PARTNER_TAG'
export const CLEAN_SELECTED_TAGS = PARTNER_TAGS + '/CLEAN_SELECTED_TAGS'
export const SET_TAGS_LOADED_FOR = PARTNER_TAGS + '/SET_TAGS_LOADED_FOR'
